import { DefaultPage, ThankyouPage } from './';
import CuponeraSeatsSelection from './Cuponera/SeatsSelection';
import CuponeraPaymentSelection from './Cuponera/PaymentSelection';
import Thankyoupage from './Cuponera/Thankyou/ThankyouPage';

export default {
  path: '/',
  name: 'Home',
  childRoutes: [
    { path: 'es', name: 'Default page', component: DefaultPage },
    { path: 'es/pasajes-bus', name: 'Default page', component: DefaultPage },
    { path: 'es/pasajes-tren', name: 'Default page', component: DefaultPage },
    { path: 'es/traslados', name: 'Default page', component: DefaultPage },
    { path: 'es/carga-bip', name: 'Default page', component: DefaultPage },
    { path: 'es/kupos-pool', name: 'Default page', component: DefaultPage },
    { path: 'es/viajes-especiales', name: 'Default page', component: DefaultPage },

    // { path: 'es/conoce-tus-derechos', name: 'Default page', component: DefaultPage },

    // Conoce tus derechos

    { path: 'en', name: 'Default page', component: DefaultPage },
    { path: 'en/bus-tickets', name: 'Default page', component: DefaultPage },
    { path: 'en/train-tickets', name: 'Default page', component: DefaultPage },
    { path: 'en/transfer', name: 'Default page', component: DefaultPage },
    { path: 'en/bip-recharge', name: 'Default page', component: DefaultPage },
    { path: 'en/kupos-pool', name: 'Default page', component: DefaultPage },
    { path: 'en/private-transport', name: 'Default page', component: DefaultPage },

    // { path: 'en/know-your-rights', name: 'Default page', component: Kn },

    { path: 'default-page', name: 'Default page', component: DefaultPage, isIndex: true },
    {
      path: 'e-bookings/:originId/:originName/:destId/:destName/:onwardDate',
      name: 'Default page',
      component: DefaultPage,
      isIndex: true,
    },
    {
      path: 'bank-transfer/booking/:status/:pnrNumber',
      name: 'Default page',
      component: ThankyouPage,
      isIndex: true,
    },

    {
      path: 'bank-transfer/booking/:status',
      name: 'Default page',
      component: ThankyouPage,
      isIndex: true,
    },

    //cuponera
    {
      path: 'cuponera/seats',
      name: 'Default page',
      component: CuponeraSeatsSelection,
      isIndex: true,
    },
    {
      path: 'cuponera/payment',
      name: 'Default page',
      component: CuponeraPaymentSelection,
      isIndex: true,
    },
    {
      path: 'cuponera/payment/:status',
      name: 'Default page',
      component: Thankyoupage,
      isIndex: true,
    },
    {
      path: 'cuponera/payment/:status/:pnr',
      name: 'Default page',
      component: Thankyoupage,
      isIndex: true,
    },

  ],
};
// http://kupas.cl/e-bookings/1646/Santiago/1905/Osorno/21-12-2019?trip_type=1&operator_id=140&is_from_operator_seo=true

//http://www.pbstage.kupas.cl/api/ui_schedules.json?origin_id=1841&destination_id=1986&travel_date=2020-03-29&show_only_available_services=false&show_injourney_services=true



// WEBPACK FOOTER //
// ./src/features/home/route.js